import  {
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import { RequestInterceptor } from './types';
import { setSessionOutHeader } from '../utils/headers';
import { checkLoggedIn } from '../utils/check-login';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only.js';

/**
 * 登陆失效拦截处理初始化参数选项
 */
export type SessionOutOptions = {
  /** 登陆失效错误码列表 */
  errCodes: string[],
  /** 登陆失效拦截后的处理 */
  handle: SessionOutHandle,
};

/**
 * 登陆失效拦截处理方法
 */
export type SessionOutHandle = (res: {
  /** 当前拦截的错误码 */
  errCode: string,
  /** 当前请求信息 */
  config: AxiosRequestConfig,
  /** 页面是否已登陆 */
  isLoggedIn: boolean;
}) => void;

/**
 * 登陆失效拦截处理类
 */
export default class SessionOutInterceptor implements RequestInterceptor {
  /**
   * 登陆失效错误码列表
   */
  errCodes: string[] = [];
  /**
   * 登陆失败拦截后的处理方法
   */
  handle!: SessionOutHandle;
  /**
   * 取消请求
   */
  abortController!: AbortController;
  /**
   * 请求是否已经取消
   */
  isSessionOut = false;

  /**
   * 构造函数
   * @param options 处理选项
   */
  constructor(options: SessionOutOptions) {
    const { errCodes, handle } = options;
    this.errCodes = errCodes;
    if (errCodes.length === 0) {
      throw new Error('errCodes is emtpy');
    }
    this.handle = handle;
    this.abortController = new AbortController();
  }

  /**
   * 处理请求
   * @param config
   * @returns
   */
  handleRequest(config: AxiosRequestConfig) {
    console.log(config.url,  'session-out');
    return Object.assign(config, { signal: this.abortController.signal });
  }

  /**
   * 处理响应
   * @param response
   * @returns
   */
  handleResponse(response: AxiosResponse) {
    const retcode = response.data.retcode || '';
    const { errCodes, handle } = this;
    const { config }  = response;

    if (errCodes.includes(retcode) && handle) {
      // 检测到登陆超时后，需取消所有后续请求
      this.abortController.abort();
      // 设置相应响应头，供后续拦截器用
      setSessionOutHeader(config);
      if (!this.isSessionOut) {
        setTimeout(() => {
          // 交给业务方处理
          handle({
            errCode: retcode as string,
            config,
            isLoggedIn: checkLoggedIn(),
          });
        });
        this.isSessionOut = true;
      }
    }
    return response;
  }
}

